export default "__VITE_ASSET__ac1cfe0c__"